import { render } from "./SubscribedAccount.vue?vue&type=template&id=349d26c6"
import script from "./SubscribedAccount.vue?vue&type=script&lang=js"
export * from "./SubscribedAccount.vue?vue&type=script&lang=js"

import "./SubscribedAccount.vue?vue&type=style&index=0&id=349d26c6&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__